import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import ytplaybutton from "../../Assets/ytplaybutton.jpeg";

const AboutUs = () => {
  const images = [ytplaybutton];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [missionOrVision, setMissionOrVision] = useState("Mission");

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Slowed down to 5 seconds
    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    const missionInterval = setInterval(() => {
      setMissionOrVision((prev) => (prev === "Mission" ? "Vision" : "Mission"));
    }, 6000); // Slowed down to 6 seconds
    return () => clearInterval(missionInterval);
  }, []);

  return (
    <Container>
      <div className="title">About Us</div>
      <div>
        <LeftSection>
          <CardContainer
            isMobile={isMobile}
            currentIndex={currentIndex}
            transition={!isMobile}
          >
            <Card key={currentIndex} src={images[currentIndex]} alt="YouTube Play Button" />
          </CardContainer>
        </LeftSection>
        <RightSection>
          <h2>
            Our <MissionText>{missionOrVision}</MissionText>
          </h2>
          <p>
            Existence Media is here to help <GradientText>creators</GradientText> and
            <GradientText> brands</GradientText> stand out in the digital world. We specialize in {" "}
            <AnimatedWord>content creation</AnimatedWord>, viral optimization, and {" "}
            <AnimatedWord>strategic growth</AnimatedWord> to turn ideas into impactful online presence.
            Whether you're a newcomer or an established creator, we provide the tools, expertise,
            and innovation to help you reach new heights.
          </p>
        </RightSection>
      </div>
    </Container>
  );
};

const fallDown = keyframes`
  0% { transform: translateY(0); opacity: 1; }
  50% { transform: translateY(20px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;

const MissionText = styled.span`
  display: inline-block;
  cursor: pointer;
  font-weight: 600;
  color: #ff6b6b;
  animation: ${fallDown} 2s ease-in-out infinite; // Slowed down to 2 seconds
`;

const Container = styled.div`
  padding: 0 2%;
  div {
    display: flex;
    margin-bottom: 1em;
    margin-top: 1em;
  }
  text-align: center;
  .title {
    margin-bottom: 0.5em;
    font-size: 2.5em;
    font-weight: 600;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
  }
  width: 100%;
  background-color: #f8f9fa;
  @media (max-width: 600px) {
    div {
      flex-direction: column;
      align-items: center;
    }
  }
`;

const LeftSection = styled.div`
  flex: 0.6;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  @media (max-width: 600px) {
    flex: none;
    width: 100%;
  }
`;

const CardContainer = styled.div`
  position: relative;
  display: flex;
  width: 300px;
  height: 400px;
  transform: ${({ currentIndex }) => `translateX(-${currentIndex * 100}%)`};
  transition: ${({ transition }) => (transition ? "transform 0.5s ease" : "none")};
`;

const Card = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  }
`;

const RightSection = styled.div`
  flex: 0.3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  transform: translateX(-10px);

  h2 {
    font-weight: 600;
    font-size: 1.8em;
  }
  p {
    color: #494949;
    padding: 0 8px;
    font-size: 1em;
  }
  @media (max-width: 600px) {
    flex: none;
    width: 100%;
    text-align: center;
    transform: none;
  }
`;

const GradientText = styled.span`
  background: linear-gradient(45deg, #ff6b6b, #f6a800);
  -webkit-background-clip: text;
  color: transparent;
`;

const AnimatedWord = styled.span`
  display: inline-block;
  position: relative;
  font-weight: 600;
  color: #333;

  &:hover {
    animation: bounce 10s ease infinite; // Slowed down to 10 seconds
  }

  @keyframes bounce {
    0% { top: 0; }
    50% { top: -4px; }
    100% { top: 0; }
  }
`;

export default AboutUs;
